import {
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Flex,
  Stack,
  Image,
} from "@chakra-ui/react";
import { modalAttention } from "../../assets/new-images";

export function AttentionModal({
  isOpen,
  onClose,
  submit,
  title,
  content,
  buttonText,
  isLoading,
  redType,
  zIndex,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay zIndex={zIndex} />
      <ModalContent
        maxW="766px"
        minW='320px'
        minH='325px'
        borderRadius="18px"
        overflow="hidden"
        boxShadow="0px 1px 4px 0px rgba(0, 0, 0, 0.25)"
        zIndex={zIndex}
        containerProps={zIndex ? { zIndex } : undefined}
      >
        <ModalBody p="40px">
          <Flex align="center" flexDir={["column-reverse", "row"]} gap="24px">
            <Stack flex={1} align="start" spacing="12px">
              <Text
                as="span"
                fontSize={["14px", "20px"]}
                color={redType ? "orange.200" : "blue.100"}
                fontWeight={600}
                lineHeight="normal"
              >
                Atenção!
              </Text>

              <Text
                fontSize={["20px", "28px"]}
                fontWeight={700}
                lineHeight="normal"
              >
                {title}
              </Text>
              {content && <Text lineHeight="24px">{content}</Text>}
            </Stack>
            <Flex flex={1} justify="center">
              <Image src={modalAttention} alt="" heigth="234px" />
            </Flex>
          </Flex>
        </ModalBody>

        <ModalFooter p={0}>
          <Button
            variant="secondary"
            size="large"
            w="100%"
            height="56px"
            borderRadius={0}
            onClick={onClose}
          >
            {buttonText || "Não"}
          </Button>
          <Button
            variant={redType ? "orange" : "close-modal"}
            size="large"
            w="100%"
            height="56px"
            borderRadius={0}
            isLoading={isLoading}
            onClick={submit}
          >
            {redType ? "Confirmar" : "Sim"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
